import axios from "axios";
import { API_URL } from "../apiConfig";

const authHeader = () => ({
  Authorization: `Bearer ${localStorage.getItem("token")}`,
});

export async function fetchMyDashboardLayout() {
  const res = await axios.get(`${API_URL}/api/users/me/dashboard-layout`, {
    headers: authHeader(),
  });
  return res.data?.layout ?? null;
}

export async function saveMyDashboardLayout(layout) {
  const res = await axios.put(
    `${API_URL}/api/users/me/dashboard-layout`,
    { layout },
    { headers: authHeader() },
  );
  return res.data?.layout ?? layout;
}

export async function clearMyDashboardLayout() {
  const res = await axios.put(
    `${API_URL}/api/users/me/dashboard-layout`,
    { clear: true },
    { headers: authHeader() },
  );
  return res.data;
}
